module.exports = __webpack_public_path__ + "static/tl-3-a194118e6489a238b6d85fbb561e98f6.png";